import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *考试列表
 * @param params
 * 
*/

export const examList = params => Http.get(`${baseUrl}/exam`, { params })

/**
 *开始考试
 * @param releaseId
 * 
*/

export const startExam = releaseId => Http.post(`${baseUrl}/exam/${releaseId}`)

/**
 *提交考试
 * @param params
 * 
*/

export const submitExam = params => Http.put(`${baseUrl}/exam/${params.receiveId}/submit`,  params.answers )

/**
 *查询试卷
 * @param params
 * 
*/

export const examInfo = releaseId => Http.get(`${baseUrl}/exam/${releaseId}`)

/**
 *重新考试
 * @param releaseId
 * 
*/

export const reExam = releaseId => Http.post(`${baseUrl}/exam/${releaseId}/redo`)

/**
 *重新考试
 * @param receiveId
 * 
*/

export const leaveScreen = receiveId => Http.put(`${baseUrl}/exam/${receiveId}/leave`)
